import { Roles } from "src/app/models/enum";

const PILOT_VIEW_ROLES = new Set<string>([Roles.PILOT, Roles.CABIN_CREW]);
const INSTRUCTOR_VIEW_ROLES = new Set<string>([Roles.INSTRUCTOR, Roles.CABIN_CREW_INSTRUCTOR]);

export function isPilotViewRole(role: string | null | undefined): boolean {
	return PILOT_VIEW_ROLES.has(normalizeRoleCode(role));
}

export function isInstructorViewRole(role: string | null | undefined): boolean {
	return INSTRUCTOR_VIEW_ROLES.has(normalizeRoleCode(role));
}

export function isCabinCrewRole(role: string | null | undefined): boolean {
	return normalizeRoleCode(role) === Roles.CABIN_CREW;
}

export function isCabinCrewInstructorRole(role: string | null | undefined): boolean {
	return normalizeRoleCode(role) === Roles.CABIN_CREW_INSTRUCTOR;
}

function normalizeRoleCode(role: string | null | undefined): string {
	return (role ?? "").trim().replace(/\s+/g, " ").toLowerCase();
}
